import { defineStore } from 'pinia'

import golfSecurityGroupApi from '@/api/golf-security-group'

import { parseErrors } from '@/helpers/error-parsers'

import { getInitialState } from './state'
import { CreateGolfAdminAccount, GolfAdmin } from '@/models/golfAdmin'
import { showToast } from '@/helpers/messages'

export const useGolfSecurityGroupStore = defineStore({
  id: 'golf-security-group-store',
  state: () => getInitialState(),
  actions: {
    async getUsers() {
      try {
        this.$patch({ listModule: { isLoading: true, error: null } })

        const {
          data: { data },
        } = await golfSecurityGroupApi.usersList()

        this.$patch({
          listModule: {
            list: data,
            isLoading: false,
            isInitialLoadingDone: true,
          },
        })
      } catch (e) {
        this.$patch({
          listModule: {
            error: parseErrors(e).error,
            isLoading: false,
            isInitialLoadingDone: true,
          },
        })
      }
    },

    async inviteUser(params: CreateGolfAdminAccount) {
      try {
        await golfSecurityGroupApi.inviteUser(params)
        await this.getUsers()
        showToast({ type: 'success', message: 'New User successfully created' })
        return true
      } catch (e) {
        const { error } = parseErrors(e)
        showToast({ type: 'error', message: error })
        return false
      }
    },

    async updateUserStatus(
      userId: string,
      params: Pick<GolfAdmin, 'golf_role' | 'golf_status'>
    ) {
      try {
        if (
          !this.$state.listModule.list.find((i: GolfAdmin) => i.id === userId)
        ) {
          throw new Error('User data must be received before updating')
        }

        const updatedUser = (
          await golfSecurityGroupApi.updateUserStatus(userId, params)
        ).data.data

        this.$patch((state: any) => {
          const list = state.listModule.list

          state.listModule.list = list.map((item: GolfAdmin) => {
            if (item.id === updatedUser.id) {
              return updatedUser
            }
            return item
          })
        })

        showToast({ type: 'success', message: 'Status updated' })
        return updatedUser
      } catch (e) {
        const { error } = parseErrors(e)
        showToast({ type: 'error', message: error })
        return null
      }
    },
  },
})
